import { api } from './api';

/**
 * Checking a project's integration, and authorising an OAuth email account. The
 * settings themselves are App Configuration (`Integration.<Channel>.<Provider>.Config`
 * plus its ENCRYPTED keys) and are edited there; these are the two things a row
 * editor cannot do. `appId` defaults to the signed-in project; another project must
 * be within the caller's scope.
 */

interface ApiResponse<T> {
  success: boolean;
  code: number;
  message: string;
  data: T;
}

export interface IntegrationTestResult {
  ok: boolean;
  /** Where it got to: reading the settings, signing in, sending, or asking status. */
  stage: 'configuration' | 'login' | 'send' | 'status';
  message: string;
}

const BASE = '/api/v1/email-account';

export const integrationAccountService = {
  /** Email signs in (and with `sendTo` sends); WhatsApp asks its instance status. */
  test: async (channel: string, appId?: string, sendTo?: string): Promise<IntegrationTestResult> =>
    (await api.post<ApiResponse<IntegrationTestResult>>(`${BASE}/test`,
      { channel, appId: appId || null, sendTo: sendTo || null })).data.data,

  /** The provider's consent URL; the browser returns to `returnUrl` afterwards. */
  startOAuth: async (returnUrl: string, appId?: string): Promise<{ authorizeUrl: string; redirectUri: string }> =>
    (await api.post<ApiResponse<{ authorizeUrl: string; redirectUri: string }>>(
      `${BASE}/oauth/start`, { returnUrl, appId: appId || null })).data.data,
};
